export default "__VITE_ASSET__DLey4xSN__"